// ignore ChunkLoadErrors in local and staging environments
// to reduce noise (and quota) in sentry
export function devChunkLoadErrors(event, hint) {
  return !(
    ['local', 'staging'].includes(event?.environment) &&
    hint?.originalException?.message?.includes?.('ChunkLoadError')
  );
}
